/**
 * API service for making HTTP requests
 */

import axios from 'axios';
import { getFirebaseAuth } from './firebase';
import { PPI_API } from './constants';


// Create axios instance with default config
const apiClient = axios.create({
  baseURL: PPI_API,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const authPpiApiAxiosWithRefresh = async () => {
  const auth = getFirebaseAuth();
  
  // Wait for Firebase to initialize and check auth state
  return new Promise<ReturnType<typeof authPpiApiAxios>>((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      unsubscribe(); // Stop listening after first check
      
      if (user) {
        try {
          const token = await user.getIdToken();
          resolve(authPpiApiAxios(token));
        } catch (error) {
          reject(new Error('Failed to get auth token'));
        }
      } else {
        reject(new Error('No authenticated user found'));
      }
    });
  });
}

export const ppiApiAxios = (() => axios.create({
  baseURL: `${PPI_API}/api`
}))();

// Secure API access (with JWT tokens included)
export const authPpiApiAxios = (token: string) => ((token: string) => axios.create({
  baseURL: `${PPI_API}/api`,
  headers: {
    Authorization: `Bearer ${token}`
  }
}))(token)


export const scoutApiAxios = (() => axios.create({
    baseURL: PPI_API
  }))()


export default apiClient;

export const getPrices = async () => {
  const response = await ppiApiAxios.get('/prices');
  return response.data;
};

export const getReportRunCount = async (docId: string) => {
  const response = await ppiApiAxios.get(`/reports/${docId}/run_count`);
  return response.data;
};